import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackScheduleReminderWishListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/wishList/trackScheduleReminderWishList";

const useTrackScheduleReminderWishList = (
    parameters: TrackScheduleReminderWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.scheduleReminderWishList, parameters, options);
};

export default useTrackScheduleReminderWishList;
